import jQuery from "jquery";

jQuery(function($) {
    let lang = 'en';

    if($("body").hasClass('lang-pl'))
        lang = 'pl';

    $('.datepicker').datepicker({
        startDate: '+1d',
        endDate: '+14d',
        weekStart: 1,
        autoclose: true,
        daysOfWeekDisabled: [0,6],
        format: "dd/mm/yyyy",
        maxViewMode: "days",
        todayHighlight: true,
        language: lang
    });
});
